module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAANCAYAAABcrsXuAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB90CHAQCMBGd5OQAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAGHRFWHRTb2Z0d2FyZQBwYWludC5uZXQgNC4wLjOM5pdQAAAAVElEQVQ4T7WN0Q4AEAgA8/8fzeZJuUzKbfcgF+LTetwraPFVhMKsCgqqdD8gUt02cLBdpNWHA2sX7dVhDgDbrBJbYwc/nNBFlQoKsl5Dy9YyXh8XGR6n1QHI3j4GAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/thieving-icon.png
// module id = 507
// module chunks = 0